import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusMoveOut00Table: GenericTableSchemaInterface = {
  id: "fms-plus-move-out-00",
  name: "FMS+ Move Out 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Move Out workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "Day of move-out SMS"
    },
    c05: {
      name: "1 day after move-out SMS"
    },
    c06: {
      name: "3 days after move-out SMS"
    },
    c07: {
      name: "5 days after move-out SMS"
    },
    c08: {
      name: "7 days after move-out SMS"
    },
    c09: {
      name: "10 days after move-out SMS"
    },
    c10: {
      name: "14 days after move-out SMS"
    },
    c11: {
      name: "30 days after move-out SMS"
    },
    c12: {
      name: "Day of move-out Email"
    },
    c13: {
      name: "1 day after move-out Email"
    },
    c14: {
      name: "3 days after move-out Email"
    },
    c15: {
      name: "5 days after move-out Email"
    },
    c16: {
      name: "7 days after move-out Email"
    },
    c17: {
      name: "10 days after move-out Email"
    },
    c18: {
      name: "14 days after move-out Email"
    },
    c19: {
      name: "30 days after move-out Email"
    },
    c20: {
      name: "SMS Link Clicked"
    },
    c21: {
      name: "Email Link Clicked"
    },
    c22: {
      name: "Review Solicitation"
    }
  }
};
